<template>
    <div class="v-list__group">
        <a :href="'/account/consultations/' + consultation.id" class="w-consultations__point r-link">
            <time class="w-consultations__time" v-html="startDate"></time>
            <span class="w-consultations__pointname" v-html="consultation.pet.name + ' was at ' + consultation.vet.user.name"></span>
        </a>
    </div>
</template>

<script>
    import dayjs from 'dayjs';

    export default {
        name: "Consultation",
        props: ['consultation'],
        data() {
            return {
                startDate: dayjs(this.consultation.start_at).format('D MMMM')
            }
        }
    }
</script>
